<main>
    <div class="flex flex-col w-full  overflow-hidden relative min-h-screen radial-gradient items-center justify-center g-0 px-4">

        <div class="justify-center items-center w-full card lg:flex max-w-md ">
            <div class=" w-full card-body">
                <a href="../" class="py-4 block"><img src="./assets/images/logos/logo.png" alt=""
                        class="mx-auto" /></a>
                <p class="mb-4 text-gray-400 text-sm text-center">Sign in </p>
                <!-- form -->
                <form>
                    
                    <div class="grid my-6" style="margin: 50px 0px;">
                        <button type="button" (click)="loginGoogle()" class="btn py-[10px] text-base text-white font-medium hover:bg-blue-700">
                            <img src="./assets/images/logos/google-logo.png" alt=""
                        style="width: 10%; height: auto; border-radius: 30%; margin-right: 30px;" /> Login with Google
                        </button>
                    </div>

                    <div class="flex justify-center gap-2 items-center">
                        <p class="text-base text-gray-400">By signing in you agree to our <a href="#"
                            class="text-sm font-semibold text-orange-600 hover:text-blue-700">Terms of Use </a>and our  
                        <a href="#"
                            class="text-sm font-semibold text-orange-600 hover:text-blue-700">Privicay Policy </a></p>
                    </div>
            <!-- </div> -->
            </form>
        </div>
    </div>

    </div>
</main>